module.exports = __webpack_public_path__ + "static/media/DSCF0014.9d79c63c.jpg";